import React from "react"
import "./TogglePreview.css"
import { getTranslation } from "../../../assets/creator/translations"
import arrowRightDisabled from "../../../assets/creator/icons/arrows/arrow-right-disabled.svg"
import arrowLeftDisabled from "../../../assets/creator/icons/arrows/arrow-left-disabled.svg"
import questionMark from "../../../assets/creator/icons/arrows/question-mark.svg"

const TogglePreview = () => (
	<div className='header-rightSide'>
		<div className='header-rightSide__container'>
			<button className='header-rightSide__container___btn arrowLeft disableArrow'>
				<img src={arrowLeftDisabled} alt={""}/>
			</button>

			<button className='header-rightSide__container___btn arrowRight disableArrow'>
				<img src={arrowRightDisabled} alt={""}/>
			</button>

			<span className='borderLine borderLine_first'></span>
			<div className='header-rightSide__container___btn questionMark'>
				<img src={questionMark} alt={""}/>
				<span className='questionMark__Helper'></span>
			</div>
			<span className='borderLine borderLine_second' />
		</div>
		<div className='toggle-preview'>
			<span className='toggle-preview__text'>{getTranslation("Preview")}</span>
		</div>
	</div>
)

export default TogglePreview;



// WEBPACK FOOTER //
// ./src/components/Header/TogglePreview/TogglePreview.js